import _objectWithoutProperties from '../../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.es.js';
import React from 'react';
import { StyledSelectListItem } from './SelectListItem.styles.es.js';

var _excluded = ["active", "selected", "onClick", "label", "id"];
var SelectListItem = function SelectListItem(props) {
  var active = props.active,
      selected = props.selected,
      onClick = props.onClick,
      label = props.label,
      id = props.id,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(StyledSelectListItem, Object.assign({}, rest, {
    id: id,
    role: "option",
    onClick: onClick,
    onKeyPress: function onKeyPress(e) {
      return e.key === 'Enter' && onClick && onClick();
    },
    "aria-selected": selected,
    selected: selected,
    active: active
  }), label);
};
SelectListItem.defaultProps = {
  active: false,
  selected: false
};

export { SelectListItem };
